import React, { useState } from 'react';
import './styles.css';
import {logo} from '../../api/api'
import { Popover,Input, message } from 'antd';
import User from './userCard';
import { UserOutlined,SearchOutlined, LogoutOutlined, LoginOutlined} from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setshowlogin } from '../../redux/actions/dashboardActions';
import { FaUserAlt} from "react-icons/fa";
import { FiSearch} from "react-icons/fi";
import { YM_LOGIN_URL } from '../../api/content-novareader';

const { Search } = Input;

const Header = (props) => {
  const dispatch = useDispatch();
  const showuser = useSelector((state) => state.App.showlogin);
  const lpp_userCredentials = JSON.parse(localStorage.getItem('lpp_userCredentials'));

  const [visible, setvisible] = useState(false)

  const history = useHistory();

  
  const handleVisibleChange = () => {
    dispatch(setshowlogin(!showuser))  
  };

  const login = () => {
    window.location.href = YM_LOGIN_URL;
  }
 

  
  

  return (
    <div className="navheader">
      <div className="notification_box">
        <div className="navlogo">
         <img src={logo} alt="" style={{  height: '100%' }} />
        </div>
      </div>
      <div className="menucontiner">
        {!props.org && <>
    {lpp_userCredentials?  <Popover open={showuser}
          trigger="click"
          onOpenChange={handleVisibleChange} content={<User hidepop={()=>handleVisibleChange()} />} >
          <div className="profile">
          <FaUserAlt className="menuicon"/>
          </div>
        </Popover>:  <LoginOutlined onClick={login} style={{ color: "#B11116", }} className="menuicon"/>}
        </>}
       
      </div>
    </div>
  )
}

export default Header;